import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OctagonDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'octagon', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const sideLength = computed({
	get: () => dimensions.value.side_length,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "side_length",
			value: value,
		});
	},
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "octagon-side_length",
        id: `${_ctx.prefix}measurements-octagon-side_length`,
        name: `${_ctx.prefix}measurements[dimensions][side_length]`,
        unit: "cm",
        label: dimensionLabel.value('side_length', 'octagon'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('side_length'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}octagon-side_length`),
        onBlur: () => _unref(addSizeToDataLayer)('side_length', +sideLength.value, 'octagon'),
        modelValue: sideLength.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sideLength).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"])
    ]),
    _: 1
  }))
}
}

})